import { render, staticRenderFns } from "./StatsList.vue?vue&type=template&id=0ed6f44b&scoped=true"
import script from "./StatsList.vue?vue&type=script&lang=js"
export * from "./StatsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed6f44b",
  null
  
)

export default component.exports